/* ==========================================================================
   Mixdiff - Free Shipping Progress (FSP)
   Extracted from snippets/free-shipping-progress.liquid so the browser can
   cache it across pages instead of re-parsing ~8.5KB of inline JS on every
   page view. Behaviour is unchanged: the script is self-initialising and
   reads its configuration from [data-mxfsp] data-attributes in the DOM.
   ========================================================================== */
(function () {
    if (window.__MXFSP_INIT__) { window.__MXFSP_REFRESH__ && window.__MXFSP_REFRESH__(); return; }
    window.__MXFSP_INIT__ = true;

    var boxes = function () { return Array.prototype.slice.call(document.querySelectorAll('[data-mxfsp]')); };

    function money(cents, box) {
      var cur = (box && box.getAttribute('data-currency')) || 'GBP';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency', currency: cur
        }).format(cents / 100);
      } catch (e) {
        return '£' + (cents / 100).toFixed(2);
      }
    }

    /* -------- fetch recommendations from Shopify product recommendations API fallback -------- */
    function fetchSuggestions(box, cb) {
      var remaining = parseInt(box.getAttribute('data-remaining'), 10) || 0;
      var cartIds = [];
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cart.items.forEach(function (it) { cartIds.push(it.product_id); });
          /* Primary: Shopify native recommendations seeded by cart items */
          var seed = cartIds.length ? '/recommendations/products.json?limit=10&product_id=' + cartIds[0] : null;
          var chain = seed
            ? fetch(seed).then(function (r) { return r.json(); }).then(function (d) { return d.products || []; })
            : Promise.resolve([]);
          return chain.then(function (prods) {
            /* Fallback: browse a condiment/hotpot collection if recs empty */
            if (!prods.length) {
              return fetch('/collections/chinese-regional-flavors/products.json?limit=50')
                .then(function (r) { return r.json(); })
                .then(function (d) { return d.products || []; })
                .catch(function () { return []; });
            }
            return prods;
          }).then(function (prods) {
            /* Never suggest what's already in the cart */
            var inCart = {};
            cart.items.forEach(function (it) { inCart[it.product_id] = true; });
            var pool = prods.filter(function (p) { return !inCart[p.id] && p.available !== false; });
            cb(pool, remaining, cart, box);
          });
        })
        .catch(function () {
          var el = box.querySelector('[data-mxfsp-cards]');
          if (el) { el.innerHTML = ''; }
        });
    }

    /* -------- pick the best add-ons: closest to the gap first, no silly small items -------- */
    function pick(pool, remaining) {
      var scored = pool.map(function (p) {
        var avail = (p.variants || []).filter(function (v) { return v.available !== false; });
        if (!avail.length) { return null; }
        var prices = avail.map(function (v) { return v.price; });
        var min = Math.min.apply(null, prices);
        var max = Math.max.apply(null, prices);
        /* Choose ONE concrete variant (and its id) — the cheapest that still
           closes the gap on its own; otherwise the most expensive available. */
        var chosen = avail[0];
        var closer = avail.filter(function (v) { return v.price >= remaining; });
        if (closer.length) {
          chosen = closer.reduce(function (a, b) { return b.price < a.price ? b : a; });
        } else {
          chosen = avail.reduce(function (a, b) { return b.price > a.price ? b : a; });
        }
        var over = chosen.price - remaining;   /* how much above the gap */
        var score;
        if (chosen.price >= remaining) {
          score = over <= 0 ? 0 : over;        /* closes it: smaller overshoot = better */
        } else {
          score = 100000 - chosen.price;       /* doesn't close it: bigger value first */
        }
        return { p: p, v: chosen, min: min, max: max, over: over, score: score };
      }).filter(Boolean);
      scored.sort(function (a, b) { return a.score - b.score; });
      /* de-dup by product id, keep top 4 */
      var seen = {}, out = [];
      for (var i = 0; i < scored.length && out.length < 4; i++) {
        var id = scored[i].p.id;
        if (seen[id]) { continue; }
        seen[id] = true;
        out.push(scored[i]);
      }
      return out;
    }

    function render(box, picks, remaining) {
      var wrap = box.querySelector('[data-mxfsp-cards]');
      if (!wrap) { return; }
      if (!picks.length) { wrap.innerHTML = ''; return; }

      /* Hint: does any single suggestion close the gap by itself? */
      var hint = box.querySelector('[data-mxfsp-hint]');
      if (hint) {
        var anySingle = picks.some(function (s) { return s.over >= 0; });
        hint.textContent = anySingle
          ? 'any one item below gets you there'
          : 'combine a couple of items to get there';
      }

      var html = '';
      picks.forEach(function (s) {
        var p = s.p;
        var img = (p.featured_image || '').replace(/(\.[a-zA-Z]+)(\?|$)/, '_300x$1$2');
        var name = p.title || '';
        var priceTxt = money(s.v.price, box);
        if (s.min !== s.max) {
          priceTxt += ' <span class="mxfsp__from">(' + money(s.min, box) + '–' + money(s.max, box) + ')</span>';
        }
        html += '<div class="mxfsp__card">' +
          (img ? '<img class="mxfsp__card-img" src="' + img + '" alt="" loading="lazy" width="300" height="300">' : '') +
          '<div class="mxfsp__card-body">' +
          '<p class="mxfsp__card-name">' + name + '</p>' +
          '<p class="mxfsp__card-price">' + priceTxt + '</p>' +
          '<button type="button" class="mxfsp__add" data-mxfsp-add="' + s.v.id + '">' +
          (s.over >= 0 ? 'Add &rarr; free shipping' : 'Add') +
          '</button></div></div>';
      });
      wrap.innerHTML = html;
    }

    /* -------- add to cart then soft-refresh the notice -------- */
    /* Delegated on document so it survives the theme replacing the ATC drawer markup */
    function bindAdd() {
      document.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-mxfsp-add]') : null;
        if (!btn) { return; }
        e.preventDefault();
        if (btn.hasAttribute('disabled')) { return; }
        var id = btn.getAttribute('data-mxfsp-add');
        btn.setAttribute('disabled', 'disabled');
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.status) { throw new Error(d.description || 'add failed'); }
            /* Let the theme's own cart JS know, then reload so totals/progress are exact */
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.cart_url) || '/cart';
          })
          .catch(function () {
            btn.removeAttribute('disabled');
            btn.textContent = 'Try again';
          });
      });
    }

    function refresh() {
      boxes().forEach(function (box) {
        /* Skip the hidden AJAX-template copy of the notice (the theme renders
           cart-item-list twice — once on the page, once inside <template>).
           Only the visible instance should fetch + render suggestions. */
        if (!box.offsetParent && box.getClientRects().length === 0) { return; }
        var remaining = parseInt(box.getAttribute('data-remaining'), 10) || 0;
        if (remaining > 0) {
          fetchSuggestions(box, function (pool, rem) {
            if (!pool.length) { return; }
            render(box, pick(pool, rem), rem);
          });
        }
      });
    }
    window.__MXFSP_REFRESH__ = refresh;

    function init() {
      /* delegated handler is bound once on document */
      if (!window.__MXFSP_CLICK_BOUND__) {
        window.__MXFSP_CLICK_BOUND__ = true;
        bindAdd();
      }
      refresh();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    /* Re-run when the theme swaps cart markup via AJAX (Empire/PXU renders templates) */
    document.addEventListener('cart:updated', function () { setTimeout(refresh, 300); });
    document.addEventListener('cart:refresh', function () { setTimeout(refresh, 300); });
  })();
